module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-regular.60fa3c0.woff";